import API from "./api";

/**
 * Persist an explicit "salary components configured" flag (same pattern as
 * payroll settings_completed). Auto-seeded defaults alone must not complete
 * the Workspace Setup step.
 */
export async function markSalaryComponentsConfigured() {
  const savedAt = new Date().toISOString();
  try {
    const res = await API.get("/organisation/me/hr-settings");
    const hr = res?.data?.hr_settings || {};
    const payroll = { ...(hr.payroll || {}) };
    if (payroll.components_completed === true && payroll.components_saved_at) {
      return payroll;
    }
    await API.patch("/organisation/me/hr-settings", {
      payroll: {
        ...payroll,
        components_completed: true,
        components_saved_at: savedAt,
      },
    });
    return { ...payroll, components_completed: true, components_saved_at: savedAt };
  } catch {
    /* non-blocking for callers that already succeeded at saving components */
    return null;
  }
}
